// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules'
// import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

    //Inner Swiper

    const innerSwiper= new Swiper('.innerSwiper', {
        modules: [Navigation, Pagination],
        navigation: {
            nextEl: ".button-next",
            prevEl: ".button-prev",
        },
        pagination: {
            el: '.swiper-pagination',
            type: "fraction"
        },
    });


    // second swiper
    const mySwiper = new Swiper(".mySwiper", {
        modules: [Navigation, Pagination],
        slidesPerView: 1.3,
        spaceBetween: 8,
        pagination: {
            el: '.swiper-pagination',
            type: "fraction",
        },
            navigation: {
            nextEl: ".my-button-next",
            prevEl: ".my-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 2.3,
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
            1280: {
                slidesPerView: 3.7,
                spaceBetween: 16,
            },
            1536: {
                slidesPerView: 4,
                spaceBetween: 16,
            }
        }
    });